export const ACTIONS = {
  SET_TOTAL_LOAN_AMOUNT: 'APPLICATION_CRITERIA:STAND_ALONE:SET_TOTAL_LOAN_AMOUNT',
  SET_SECURITY_VALUE: 'APPLICATION_CRITERIA:STAND_ALONE:SET_SECURITY_VALUE',
  SET_LOAN_VALUE_RATIO: 'APPLICATION_CRITERIA:STAND_ALONE:SET_LOAN_VALUE_RATIO',
  UPDATE_CRITERIA: 'APPLICATION_CRITERIA:STAND_ALONE:UPDATE_CRITERIA',
  UPDATE_SELECTED_LENDER_NAMES: 'APPLICATION_CRITERIA:STAND_ALONE:UPDATE_SELECTED_LENDER_NAMES',
  MODIFY_CRITERIA: 'APPLICATION_CRITERIA:STAND_ALONE:MODIFY_CRITERIA',
  SUBMIT_MODIFIED_CRITERIA: 'APPLICATION_CRITERIA:STAND_ALONE:SUBMIT_MODIFIED_CRITERIA',
};
